import { getObjectUtil } from 'packages/src'
import WORKOUT_SECTIONS_PATH from '../../constants/path'

const getCurrentWorkoutSectionSelect = state => {
  return getObjectUtil(state, WORKOUT_SECTIONS_PATH.DATA)[getObjectUtil(
    state,
    WORKOUT_SECTIONS_PATH.CURRENT
  )]
}

export default getCurrentWorkoutSectionSelect
